import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ScoresLink',
  props: {
  title: String,

},
  emits: ["showCalculator"],
  setup(__props, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showCalculator'))),
    type: "button",
    class: "text-white font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mt-4 link"
  }, _toDisplayString(__props.title), 1))
}
}

})